<template>
    <div class="loginbody">
        <div class="logindata">
            <div class="logintext">
                <h2>Welcome</h2>
            </div>
            <div class="formdata">
                <el-form ref="form" :model="form">
                    <el-form-item prop="username">
                        <el-input v-model="form.username" placeholder="请输入账号"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="form.password" placeholder="请输入密码" show-password></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="butt">
                <el-button type="primary" @click.native.prevent="login">登录</el-button>
                <el-button class="shou" @click="register">注册</el-button>
            </div>
        </div>
    </div>
</template>
  
<script>
import { getInstance } from './api/orm'
import { setUser, setToken, getUser } from './api/user'
export default {
    name: "login-page",
    data() {
        return {
            form: {
                password: "",
                username: "",
            },
            maskVisable: false
        };
    },
    async created() {
        let user = await getUser();
        if (user) {
            this.$router.push("/");
        }
    },
    methods: {
        async login() {
            let orm = getInstance({ app_name: 'auth', model_name: 'user' });
            let res = await orm.login({ post: { username: this.form.username, password: this.form.password } });
            if (res) {
                setToken(res);
                let user = await orm.current_user({});
                if (user) {
                    setUser(user);
                    this.$router.push("/");
                }
            }
        },
        register() {

        }
    },
};
</script>
  
<style scoped>
.loginbody {
    width: 100%;
    height: 100%;
    min-width: 1000px;
    background-size: 100% 100%;
    background-position: center center;
    overflow: auto;
    background-repeat: no-repeat;
    position: fixed;
    line-height: 100%;
    padding-top: 150px;
}

.logintext {
    margin-bottom: 20px;
    line-height: 50px;
    text-align: center;
    font-size: 30px;
    font-weight: bolder;
    color: white;
    text-shadow: 2px 2px 4px #000000;
}

.logindata {
    width: 400px;
    height: 300px;
    transform: translate(-50%);
    margin-left: 50%;
}

.tool {
    display: flex;
    justify-content: space-between;
    color: #606266;
}

.butt {
    margin-top: 10px;
    text-align: center;
}

.shou {
    cursor: pointer;
    color: #606266;
}

/*ui*/
/* /deep/ .el-form-item__label {
    font-weight: bolder;
    font-size: 15px;
    text-align: left;
  }
  
  /deep/ .el-button {
    width: 100%;
    margin-bottom: 10px;
  
  } */
</style>
  
  